import { ApiService } from "../../../../services/api.service"
import { getRoleSetState } from "./getRoleSetState"
import { navigate } from "gatsby"
import * as decode from "jwt-decode"
import { logout } from "./index"

/**
 * @function appWindowReload - This function is fired in the Auth context useEffect, so anytime a window is reloaded or opened to check the user's auth state
 * @param setState - hook to set the Auth context state
 * @param removeCookie - hook to remove cookie
 */
export const appWindowReload = (cookies, setState, removeCookie) => {
  if (typeof window !== "undefined") {
    if (
      !window.location.pathname.includes("resetpassword") &&
      !window.location.pathname.includes("loginredirect")
    ) {
      if (cookies.hallenToken) {
        const {
          name,
          roleId,
          userID,
          aliasUsername,
          aliasRoleID,
          aliasEmpID,
          empID,
        } = decode(cookies.hallenToken)
        const employeeParams = new URLSearchParams({
          employeeID: aliasEmpID ? aliasEmpID : "me",
        })
        ApiService.get(process.env.EMPLOYEE_DETAIL, employeeParams).then(
          (res: any) => {
            if (res.status === 200) {
              setState(prevState => ({
                ...prevState,
                employeeDetails: { ...res.data.data[0] },
              }))
            }
            getRoleSetState(
              aliasUsername || name,
              aliasRoleID || roleId,
              userID,
              aliasEmpID || empID,
              setState,
              logout,
              cookies.hallenToken,
              removeCookie
            ).then(() => {
              setState(prevState => ({
                ...prevState,
                aliased: !!aliasUsername,
              }))
              navigate(window.location.pathname + window.location.search)
            })
          }
        )
      } else {
        logout(removeCookie, setState)
      }
    } else {
      setState(prevState => ({ ...prevState, loading: false }))
    }
  }
}
